import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["triggerRef"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Button from '@atlaskit/button/standard-button';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import MoreIcon from '@atlaskit/icon/glyph/more';
import { MenuItemClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { useFlagsImplementation } from '@atlassian/mpac-ui';
import React, { useState } from 'react';
import { ANALYTICS_OBJECT_TYPE_APP_REQUESTS, ANALYTICS_SUBJECT_ID_APPROVE_REQUEST, ANALYTICS_SUBJECT_ID_REJECT_REQUEST } from '../../../../../analytics/Events';
import getSPI from '../../../../../services/SPI';
import { useEnvironment } from '../../../../AppContext';
import { AppInstallLocation, getAppInstallConfigForEnv, useMarketplaceAppInstall } from '../../../../AppInstallDialog';
import RejectRequestModal from './RejectRequestModal';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function AppRequestActionsAlternateLayout(props) {
  const fireAnalyticsEvent = useAnalyticsEvents();
  const [isActionsOpen, setIsActionOpen] = useState(false);
  const [isRejectRequestModalOpen, setIsRejectRequestModalOpen] = useState(false);
  const environment = useEnvironment();
  const {
    installerElement,
    installApp
  } = useMarketplaceAppInstall(getSPI(), getAppInstallConfigForEnv(environment), AppInstallLocation.EmbeddedMarketplaceManageAppRequests);
  const {
    showFlag,
    dismissFlag
  } = useFlagsImplementation();
  const onRejectClick = () => {
    fireAnalyticsEvent({
      eventType: MenuItemClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_REJECT_REQUEST,
      objectType: ANALYTICS_OBJECT_TYPE_APP_REQUESTS,
      objectId: props.appRequest.appDetails.appKey
    });
    setIsRejectRequestModalOpen(true);
  };
  const onApproveInstallClick = () => {
    if (props.appKey) installApp(props.appKey, {
      flags: {
        show: flag => showFlag(flag),
        dismiss: id => dismissFlag(id)
      }
    });
    fireAnalyticsEvent({
      eventType: MenuItemClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_APPROVE_REQUEST,
      objectType: ANALYTICS_OBJECT_TYPE_APP_REQUESTS,
      objectId: props.appRequest.appDetails.appKey
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isRejectRequestModalOpen && /*#__PURE__*/_jsx(RejectRequestModal, {
      appKey: props.appRequest.appDetails.appKey,
      appName: props.appRequest.appDetails.name,
      appRequestDefaultParams: props.appRequestDefaultParams,
      closeModal: () => setIsRejectRequestModalOpen(false),
      requestCount: props.appRequest.requestCount,
      onReject: props.onReject
    }), /*#__PURE__*/_jsx(DropdownMenu, {
      isOpen: isActionsOpen,
      onOpenChange: () => setIsActionOpen(!isActionsOpen),
      trigger: _ref => {
        let {
            triggerRef
          } = _ref,
          triggerProps = _objectWithoutProperties(_ref, _excluded);
        return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
          ref: triggerRef
        }, triggerProps), {}, {
          isSelected: isActionsOpen,
          iconAfter: /*#__PURE__*/_jsx(MoreIcon, {
            testId: "app-request__actions-icon",
            label: "App request actions"
          }),
          isDisabled: props.isActionsDisabled
        }));
      },
      children: /*#__PURE__*/_jsxs(DropdownItemGroup, {
        children: [/*#__PURE__*/_jsx(DropdownItem, {
          onClick: onApproveInstallClick,
          testId: "app-request__approve-and-install",
          children: "Approve and install"
        }), /*#__PURE__*/_jsx(DropdownItem, {
          onClick: onRejectClick,
          testId: "app-request__reject",
          children: "Reject"
        })]
      })
    }), installerElement]
  });
}
export default AppRequestActionsAlternateLayout;